import React from 'react';
import { motion } from 'framer-motion';
import { Countdown } from '../ui/Countdown';
import { launchPrices } from '../../data/content';
export function Urgency() {
  return <section className="py-16 relative" data-id="element-304" data-mp="2bjgs4ntk5zse">
      <div className="container mx-auto px-4" data-id="element-305" data-mp="2bki2sr6nwk9l">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto text-center p-8 md:p-12 rounded-3xl bg-surface border border-pistachio-300" data-id="element-306" data-mp="2blbd224txrwh">
          <h2 className="text-xl md:text-2xl font-bold text-ink mb-2 flex items-center justify-center gap-2" data-id="element-307" data-mp="2z9ktspn6rpgr">
            <span aria-hidden="true" data-id="element-308" data-mp="2ugi1eku5am25">⏰</span> PRECIO DE LANZAMIENTO
          </h2>
          <p className="text-muted mb-8" data-id="element-309" data-mp="2pigcvkdy9uja">
            Cerrá la semana con el sistema. Después sube.
          </p>

          <div className="mb-8" data-id="element-310" data-mp="3mzyf7xb9mq2d">
            <Countdown data-id="element-311" data-mp="3i86wua29jqnb" />
          </div>

          <div className="overflow-x-auto hide-scrollbar rounded-2xl border border-line mb-8 text-left" data-id="element-312" data-mp="3i759b6429bop">
            <table className="w-full min-w-[420px] border-collapse" data-id="element-313" data-mp="k1i43x4k1bbo">
              <thead data-id="element-314" data-mp="ozjjo82rusie">
                <tr className="bg-pistachio-50 border-b border-line" data-id="element-315" data-mp="oxyqals71fm4">
                  <th className="p-4 text-sm font-semibold text-ink" data-id="element-316" data-mp="b8esludgz8jo">Producto</th>
                  <th className="p-4 text-sm font-semibold text-muted" data-id="element-317" data-mp="f9gpw5nttaj0">Precio normal</th>
                  <th className="p-4 text-sm font-semibold text-pistachio-800" data-id="element-318" data-mp="f7457kqoom29">
                    Precio lanzamiento
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-line" data-id="element-319" data-mp="66pda2j7s8ps">
                {launchPrices.map(row => <tr key={row.name} data-id="element-320" data-mp="3oghx3jpcva0d">
                    <td className="p-4 text-sm font-medium text-ink" data-id="element-321" data-mp="3sfgw6noeocjw">{row.name}</td>
                    <td className="p-4 text-sm text-muted line-through" data-id="element-322" data-mp="1mnbj78pay5t5">{row.normal}</td>
                    <td className="p-4 text-sm font-bold text-pistachio-800 bg-pistachio-100/70" data-id="element-323" data-mp="1qonarjrql13z">
                      {row.launch}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>

          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-clay-50 text-clay-700 font-medium text-sm mb-8 border border-clay-100" data-id="element-324" data-mp="2ulpqh7v46lgq">
            <span aria-hidden="true" data-id="element-325" data-mp="2lm2ks9vcqthv">⚠️</span> Después del lanzamiento sube $8.000 ARS. No
            vuelve.
          </div>

          <div className="max-w-md mx-auto" data-id="element-326" data-mp="3icbo057hsnch">
            <p className="text-sm font-medium text-clay-700 mb-2 text-left flex items-center gap-2" data-id="element-327" data-mp="3ie64n7bqdtar">
              <span aria-hidden="true" className="text-[10px]" data-id="element-328" data-mp="3eckw1y68c16d">
                🔴
              </span>{' '}
              Cupos al precio de lanzamiento — Quedan pocos
            </p>
            <div className="h-3 w-full bg-pistachio-100 rounded-full overflow-hidden border border-line" data-id="element-329" data-mp="34kexg5lh2li7">
              <motion.div initial={{
              width: 0
            }} whileInView={{
              width: '68%'
            }} viewport={{
              once: true
            }} transition={{
              duration: 1.5,
              ease: 'easeOut'
            }} className="h-full bg-clay-400 rounded-full" data-id="element-330" data-mp="5wrh3nrjqxrf" />
            </div>
            <p className="text-xs text-muted mt-2 text-right" data-id="element-331" data-mp="dg0q3fw54ufy">
              68% de los cupos al precio de lanzamiento ya tomados
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}